export default __webpack_public_path__ + "static/media/DeepDesertMap.c09099a4.jpg";